var map = {
	"./cake.webp": 2315,
	"./correct-ico.webp": 2316,
	"./crown-blue.webp": 2317,
	"./crown.webp": 2318,
	"./pocket.webp": 2319,
	"./present.webp": 2320,
	"./relegation.webp": 2321,
	"./t-deposit.webp": 2322,
	"./t-turnover.webp": 2323,
	"./vip-1.webp": 2324,
	"./vip-2.webp": 2325,
	"./vip-3.webp": 2326,
	"./vip-4.webp": 2327,
	"./vip-5.webp": 2328,
	"./vip-badge.webp": 2329,
	"./vip-bg.webp": 2330,
	"./vip2.webp": 2331,
	"./vip3.webp": 2332,
	"./vip4.webp": 2333,
	"./vip5.webp": 2334,
	"./vip6.webp": 2335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 847;